import { render, staticRenderFns } from "./sign.vue?vue&type=template&id=33805419&scoped=true"
var script = {}
import style0 from "./sign.vue?vue&type=style&index=0&id=33805419&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33805419",
  null
  
)

export default component.exports